export enum ConsentCode {
  UNKNOWN = '0', // no headers values, fallback to timezone check
  NOT_REQUIRED = '1', // user is not in EU or CA so no consent required
  ADS_REQUIRED = '2', // ads required for EU, CA
  BOTH_REQUIRED = '3', // ads and analytics required for EU
}

export type ConsentState = {
  ads: boolean; // (meta/tiktok) required for EU, CA
  analytics?: boolean; // (GA4) required for EU. Undefined for CA.
  timestamp: number;
};

export type ConsentContextValue = {
  resolvedCode: ConsentCode;
  hasUserChosen: boolean;
  requiresConsent: boolean;
  allowAds: boolean;
  allowAnalytics: boolean;
  acceptNecessaryOnly: () => void;
  acceptAll: () => void;
};
